module.exports = __webpack_public_path__ + "static/media/23_plantilla_combo_cuadrada_marco_comida_46.eaa38d1b.png";